"use client";
import symbology from "@/lib/symbology";
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "./ui/tooltip";

interface Props {
	symbols: string;
	noMatchText?: string;
	size?: number;
	enableTooltip?: boolean;
}

const symbolRegex = /({[^{}]*})/g;

export const MagicSymbols = ({
	symbols,
	noMatchText = "-",
	size = 24,
	enableTooltip = true,
}: Props) => {
	const matches = symbols.match(symbolRegex);
	const foundSymbols = matches
		? matches
				.map((match) => symbology.find((symbol) => symbol.symbol === match))
				.filter((s) => s)
		: [];

	return foundSymbols ? (
		<>
			{foundSymbols.map((symbol, index) => (
				<TooltipProvider
					key={`${symbol}-${
						// biome-ignore lint/suspicious/noArrayIndexKey: It's unique enough in combination with the symbol content
						index
					}`}
				>
					<Tooltip open={enableTooltip ? undefined : false}>
						<TooltipTrigger asChild>
							<img
								alt={symbol?.english}
								src={symbol?.svg_uri}
								style={{ height: size, width: size }}
							/>
						</TooltipTrigger>
						<TooltipContent>
							<p>{symbol?.english}</p>
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>
			))}
		</>
	) : (
		<p>{noMatchText}</p>
	);
};
